"use client"

import { ToastType, useToast } from "@/app/context/ToastContext"
import { Icon, IconColor, IconName, IconSize } from "@components/icons/Icon"
import styles from "./Toaster.module.css"
import clsx from "clsx"

export const Toaster = () => {
  const { toasts, removeToast } = useToast()

  if (toasts.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      {toasts.map((toast) => (
        <ToastItem
          key={toast.id}
          toast={toast}
          onDismiss={() => removeToast(toast.id)}
        />
      ))}
    </div>
  )
}

export const ToastItem = ({
  toast,
  onDismiss,
}: {
  toast: {
    id: string
    message: string
    type: ToastType
  }
  onDismiss: () => void
}) => {
  return (
    <div className={`${styles.toast} ${styles[toast.type]}`}>
      <span className={clsx("subHeadline", styles.message)}>
        {toast.message}
      </span>
      <button
        className={styles.closeButton}
        onClick={onDismiss}
        aria-label="Close toast"
      >
        <Icon
          name={IconName.CrossLarge}
          size={IconSize.Small}
          color={IconColor.White}
        />
      </button>
    </div>
  )
}
